<!-- TODO: KQ: improve track property -->
@for (activity of activities; track activity) {
  @if (isComment(activity)) {
    <app-ticket-comment [site]="site"
                        [comment]="activity"
                        [assigneesByEmail]="assigneesByEmail"
                        [allowEdit]="!readOnly"
                        (editComment)="onEdit($event)" />
  } @else if (isChangeHistory(activity)) {
    <app-ticket-change-history [site]="site"
                               [ticketType]="ticketType"
                               [changeHistory]="activity"
                               [equipmentLoading]="equipmentLoading"
                               [equipmentById]="equipmentById"
                               [impactsLoading]="impactsLoading"
                               [impactsById]="impactsById"
                               [prioritiesLoading]="prioritiesLoading"
                               [prioritiesById]="prioritiesById"
                               [oldActionPrioritiesById]="oldActionPrioritiesById"
                               [actionPriorityUpgradeStart]="ACTION_PRIORITY_UPGRADE_START_TS"
                               [actionPriorityUpgradeEnd]="ACTION_PRIORITY_UPGRADE_END_TS" />
  }
}
